import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { extendTheme } from '@chakra-ui/react'
import { GlobalStoreProvider } from "./context/GlobalStoreProvider";
import { ChakraProvider } from '@chakra-ui/react';
import RoutedView from './routes/Routes';
import {
  BrowserRouter,
  Route,
  useParams
} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <ChakraProvider theme={extendTheme({
    fonts: {
      heading: 'Inter var, sans-serif',
      body: 'Inter var, sans-serif',
    },
  })}>
    <GlobalStoreProvider>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/inter-ui/3.19.3/inter.css" />
      <BrowserRouter>
          <RoutedView />
      </BrowserRouter>
    </GlobalStoreProvider>
  </ChakraProvider>
</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
